module.exports = __webpack_public_path__ + "media/images/logo-white-c1a8fd4b.svg";